import { useAuth } from "@/app/auth";
import { useOutbox } from "@/offline";
import { LogOut } from "lucide-react";
import { useState } from "react";

export function waitingLoadsText(count: number): string {
  const loads =
    count === 1 ? "1 dato que todavía no salió" : `${count} datos que todavía no salieron`;
  return `Hay ${loads} al CRM. Quedan guardados en el teléfono y salen cuando vuelvas a entrar con tu usuario: si cerrás sesión ahora, no salen hasta entonces.`;
}

export function legacyItemsText(count: number): string {
  const items = count === 1 ? "Queda 1 aviso" : `Quedan ${count} avisos`;
  return `${items} de la versión anterior de la app. No se envían: si cerrás sesión quedan guardados en el teléfono y los volvés a ver cuando entres con tu usuario.`;
}

export function SignOutSection() {
  const { signOutFromDevice } = useAuth();
  const outbox = useOutbox();
  const [confirming, setConfirming] = useState(false);

  const waiting = outbox.items.length;
  const legacy = outbox.stale.length;

  return (
    <section className="lead-group">
      {confirming ? (
        <>
          <h2 className="t-eyebrow">¿Cerrar sesión?</h2>
          <p className="profile__note">
            Se borra el PIN y la contraseña guardada en este teléfono. Para volver a entrar vas a
            necesitar señal y tu contraseña.
          </p>
          {waiting > 0 ? (
            <p className="notice notice--offline">{waitingLoadsText(waiting)}</p>
          ) : null}
          {legacy > 0 ? <p className="notice notice--info">{legacyItemsText(legacy)}</p> : null}
          <div className="profile__confirm">
            <button
              type="button"
              className="btn btn--primary btn--block"
              onClick={() => void signOutFromDevice()}
            >
              Sí, cerrar sesión
            </button>
            <button type="button" className="btn btn--block" onClick={() => setConfirming(false)}>
              Seguir trabajando
            </button>
          </div>
        </>
      ) : (
        <ul className="lead-rows">
          <li className="lead-rows__item">
            <button
              type="button"
              className="lead-row lead-row--button profile-action profile-action--danger"
              onClick={() => setConfirming(true)}
            >
              <LogOut size={18} aria-hidden="true" />
              Cerrar sesión
            </button>
          </li>
        </ul>
      )}
    </section>
  );
}
